import { render, staticRenderFns } from "./PerformerInfo.vue?vue&type=template&id=75daedd8&scoped=true&"
import script from "./PerformerInfo.vue?vue&type=script&lang=js&"
export * from "./PerformerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PerformerInfo.vue?vue&type=style&index=0&id=75daedd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75daedd8",
  null
  
)

export default component.exports